import React, { useState, useEffect } from "react";
import { Cookie, X, Shield } from "lucide-react";

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      // Small delay for smooth appearance
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem("cookie_consent", JSON.stringify({ technical: true, analytics: false, timestamp: new Date().toISOString() }));
    setIsVisible(false);
  };

  const acceptTechnicalOnly = () => {
    localStorage.setItem("cookie_consent", JSON.stringify({ technical: true, analytics: false, timestamp: new Date().toISOString() }));
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[90] p-4 md:p-6"
      data-testid="cookie-banner"
    >
      <div className="max-w-4xl mx-auto bg-white border border-slate-200 rounded-2xl shadow-[0_-8px_40px_rgba(0,0,0,0.1)] overflow-hidden">
        <div className="p-6 md:p-8">
          <div className="flex items-start gap-4">
            {/* Icon */}
            <div className="hidden sm:flex w-12 h-12 rounded-xl bg-gradient-to-r from-teal-500/10 to-emerald-500/10 items-center justify-center flex-shrink-0 mt-1">
              <Cookie className="w-6 h-6 text-teal-600" />
            </div>

            {/* Content */}
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2">
                <Cookie className="w-5 h-5 text-teal-600 sm:hidden" />
                <h3 className="text-lg font-medium font-['Outfit'] text-slate-900">
                  Informativa sui Cookie
                </h3>
              </div>
              <p className="text-slate-600 text-sm leading-relaxed mb-1">
                Questo sito utilizza esclusivamente <strong>cookie tecnici</strong> necessari al suo corretto funzionamento. 
                Non utilizziamo cookie di profilazione o di terze parti per finalità di marketing.
              </p>
              <p className="text-slate-500 text-xs leading-relaxed">
                Ai sensi del Regolamento (UE) 2016/679 (GDPR) e del D.Lgs. 196/2003, i cookie tecnici non richiedono il consenso preventivo 
                ma ti informiamo del loro utilizzo per trasparenza. Per maggiori dettagli consulta la nostra Privacy Policy.
              </p>
            </div>
          </div>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 mt-5 sm:justify-end">
            <button
              onClick={acceptTechnicalOnly}
              className="text-slate-600 hover:text-slate-900 text-sm font-medium px-5 py-2.5 rounded-full border border-slate-200 hover:bg-slate-50 transition-all"
              data-testid="cookie-accept-technical-btn"
            >
              Solo necessari
            </button>
            <button
              onClick={acceptAll}
              className="bg-gradient-to-r from-teal-500 to-emerald-800 text-white text-sm font-medium px-6 py-2.5 rounded-full hover:opacity-90 hover:shadow-lg transition-all"
              data-testid="cookie-accept-all-btn"
            >
              Ho capito, accetto
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
